<template lang='pug'>
  i.svg-icon.svg-icon-info
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )

      path(d='M50,3.167C24.175,3.167,3.167,24.175,3.167,50c0,25.826,21.008,46.834,46.833,46.834 c25.826,0,46.833-21.008,46.833-46.834C96.833,24.175,75.826,3.167,50,3.167z M48.049,81.223c-3.229,0-5.854-2.626-5.854-5.854 c0-3.229,2.625-5.854,5.854-5.854s5.854,2.625,5.854,5.854C53.902,78.597,51.277,81.223,48.049,81.223z M53.902,57.417v6.243 c0,1.078-0.872,1.95-1.95,1.95h-7.806c-1.079,0-1.951-0.872-1.951-1.95v-9.758c0-4.303,3.502-7.805,7.805-7.805 c4.303,0,7.806-3.502,7.806-7.806S54.303,30.486,50,30.486c-4.303,0-7.805,3.502-7.805,7.805v1.951 c0,1.079-0.873,1.952-1.952,1.952h-7.805c-1.079,0-1.951-0.873-1.951-1.952v-1.951c0-10.759,8.754-19.514,19.514-19.514 c10.76,0,19.515,8.754,19.515,19.514C69.515,47.656,62.917,55.591,53.902,57.417z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>